import { defineComponent, onMounted, PropType, ref } from 'vue';
import { ProjectForm } from '@/store/project/project.model';
import ProjectFormComponent from '@/components/project/create/createComponents/projectForm/ProjectForm.vue';

export default defineComponent({
  name: 'ProjectTabComponent',
  components: {
    ProjectFormComponent
  },
  emits: [
    'next'
  ],
  props: {
    project: {
      type: Object as PropType<ProjectForm>,
      required: true,
    }
  },
  setup: (_, context) => {
    const projectForm = ref<InstanceType<typeof ProjectFormComponent>>();

    onMounted(() => {
      projectForm.value?.unsubmit();
    });

    const nextClick = () => {
      projectForm.value?.submitForm();
    };

    const validated = (projectData: ProjectForm) => {
      context.emit('next', projectData);
    };

    return {
      projectForm,
      nextClick,
      validated,
    };
  },
});
